import React from 'react';
import logo from "../../logo.png"

function Form4() {
  return (
    <div className="flex flex-col items-center justify-center w-3/4 h-screen text-gray-800 font-sans">
        <header className="text-4xl mb-4">Cubicaciones</header>
        <header className="text-2xl mb-4">Próximamente</header>
        <div className="text-lg text-center max-w-md mb-8">
          
          <p>Estamos trabajando en ello.</p>
        <p>
          Visita nuestras otras secciones.
        </p>
      </div>
      <img src={logo} className="w-1/3 rounded-full"></img>
      <footer className="text-sm mt-8">
        © 2024 DrawingsMachines - Todos los derechos reservados.
      </footer>
    </div>
  )
}

export default Form4;
